module.exports = " <div :style=\"{height: height + 'px',position: 'relative', overflow: 'hidden'}\"> <slot></slot> </div> ";


//////////////////
// WEBPACK FOOTER
// ./~/.1.2.3@vue-html-loader!./~/.8.7.0@vue-loader/lib/selector.js?type=template&index=0!./~/.0.1.3@vux/src/components/blur/index.vue
// module id = 202
// module chunks = 2